module.exports = __webpack_public_path__ + "static/unnamed-a41d69d31c4ecd01edfc0703b7ad9ca1.jpg";